/* Potato & Co. Wishlist
 * One list per shopper. Items are kept in this browser until the shopper
 * finishes the list. Finishing creates one share link that carries everything
 * (exact variant + custom photo/name details), so nothing is stored on a
 * server and the site is not slowed down.
 * A finished list can be edited: the shopper re-opens it, changes items and
 * saves, which creates a NEW link. Each item keeps a stable number ("n") so
 * gifts already bought from the list stay marked as gifted after edits.
 */
(function () {
  'use strict';

  var CFG = window.PotatoWishlistConfig || {};
  var KEY = 'potato_wishlist_v1';
  var MAX_ITEMS = 60;
  var BRAND = { bg: '#F5EFE4', ink: '#362624', soft: '#8A7A6E', tile: '#FFFFFF', accent: '#7A1F2E' };

  /* ---------- helpers ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function load() {
    try { var s = JSON.parse(localStorage.getItem(KEY)); if (s && Array.isArray(s.items)) return s; } catch (e) {}
    return { items: [], finished: false, link: '', name: '', note: '' };
  }
  function save(s) { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }
  function abs(src, width) {
    if (!src) return '';
    var u = src.indexOf('//') === 0 ? 'https:' + src : src;
    if (width) u += (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
    return u;
  }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD';
    try { return (cents / 100).toLocaleString('en-CA', { style: 'currency', currency: cur }); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function wishlistUrl(extra) {
    var u = (CFG.pageUrl || '/collections/all?view=wishlist');
    if (extra) u += (u.indexOf('?') > -1 ? '&' : '?') + extra;
    return u;
  }
  function isImageUrl(v) {
    return /^https:\/\/\S+$/i.test(v) && (/\.(png|jpe?g|webp|gif|heic|avif)(\?|$)/i.test(v) || /upload/i.test(v));
  }
  function sameItem(a, b) {
    return String(a.v) === String(b.v) && JSON.stringify(a.p || {}) === JSON.stringify(b.p || {});
  }
  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('missing'); return r.json(); });
  }
  function visibleProps(p) {
    var out = [];
    Object.keys(p || {}).forEach(function (k) { if (k.charAt(0) !== '_' && String(p[k]).trim() !== '') out.push([k, String(p[k])]); });
    return out;
  }
  function propsHtml(p) {
    var rows = visibleProps(p);
    if (!rows.length) return '';
    return '<ul class="pw-props">' + rows.map(function (r) {
      if (isImageUrl(r[1])) {
        return '<li class="pw-prop pw-prop--img"><span>' + esc(r[0]) + '</span><img src="' + esc(r[1]) + '" alt="' + esc(r[0]) + '" loading="lazy"></li>';
      }
      return '<li class="pw-prop"><span>' + esc(r[0]) + ':</span> ' + esc(r[1]) + '</li>';
    }).join('') + '</ul>';
  }

  function newListId() {
    var chars = 'abcdefghijklmnopqrstuvwxyz0123456789', out = 'w', bytes = new Uint8Array(11);
    (window.crypto || window.msCrypto).getRandomValues(bytes);
    for (var i = 0; i < bytes.length; i++) out += chars.charAt(bytes[i] % chars.length);
    return out;
  }
  // Items bought from this wishlist (recorded by a Shopify Flow) -> array of item numbers.
  function fetchGifted(listId) {
    if (!listId || !/^w[a-z0-9]{6,20}$/.test(listId)) return Promise.resolve([]);
    return fetch('/search?q=' + listId + '&view=wishlistgifts', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : []; })
      .then(function (j) { return Array.isArray(j) ? j.map(String) : []; })
      .catch(function () { return []; });
  }

  /* ---------- link encoding (compressed, URL-safe) ---------- */
  function b64urlFromBytes(bytes) {
    var bin = ''; for (var i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
    return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function bytesFromB64url(s) {
    s = s.replace(/-/g, '+').replace(/_/g, '/'); while (s.length % 4) s += '=';
    var bin = atob(s), out = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
    return out;
  }
  function encodeList(obj) {
    var bytes = new TextEncoder().encode(JSON.stringify(obj));
    if (typeof CompressionStream === 'undefined') return Promise.resolve('j' + b64urlFromBytes(bytes));
    var stream = new Blob([bytes]).stream().pipeThrough(new CompressionStream('deflate-raw'));
    return new Response(stream).arrayBuffer().then(function (buf) { return 'z' + b64urlFromBytes(new Uint8Array(buf)); });
  }
  function decodeList(str) {
    var kind = str.charAt(0), bytes = bytesFromB64url(str.slice(1));
    var p = kind === 'z'
      ? new Response(new Blob([bytes]).stream().pipeThrough(new DecompressionStream('deflate-raw'))).text()
      : Promise.resolve(new TextDecoder().decode(bytes));
    return p.then(function (t) { return JSON.parse(t); });
  }

  /* ---------- product page: capture exactly what the shopper picked ---------- */
  function captureSelection() {
    var form = $('form[data-type="add-to-cart-form"]') || $('form[action*="/cart/add"]');
    var els = [];
    if (form) {
      els = Array.prototype.slice.call(form.elements);
      if (form.id) els = els.concat(Array.prototype.slice.call(document.querySelectorAll('[form="' + form.id + '"]')));
    }
    // apps sometimes render custom fields just outside the form
    els = els.concat(Array.prototype.slice.call(document.querySelectorAll('[name^="properties["]')));

    var vid = new URLSearchParams(location.search).get('variant') || '';
    var props = {};
    els.forEach(function (el) {
      if (!el.name) return;
      if (el.name === 'id' && el.value && !vid && !el.disabled) vid = el.value;
      var m = el.name.match(/^properties\[(.+)\]$/);
      if (!m || el.type === 'file') return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      var val = (el.value || '').trim();
      if (val && !(m[1] in props)) props[m[1]] = val;
    });
    if (!vid) {
      els.some(function (el) { if (el.name === 'id' && el.value) { vid = el.value; return true; } return false; });
    }
    if (!vid && CFG.product) vid = String(CFG.product.firstVariant);
    return { v: vid, p: props };
  }

  function initProductButton() {
    if (!CFG.product) return;
    var form = $('form[data-type="add-to-cart-form"]') || $('form[action*="/cart/add"]');
    var anchor = form ? (form.closest('.product__info') || form) : null;
    if (!anchor) return;

    var wrap = document.createElement('div');
    wrap.className = 'pw-pdp';
    wrap.innerHTML =
      '<button type="button" class="pw-btn pw-btn--outline pw-add"><span class="pw-heart" aria-hidden="true">&#9825;</span> <span class="pw-add-label">Add to Wishlist</span></button>' +
      '<p class="pw-hint" hidden>Customizing? Add your photo, name or other details first, then tap Add to Wishlist so they’re saved.</p>' +
      '<p class="pw-msg" role="status" aria-live="polite"></p>';
    anchor.parentNode.insertBefore(wrap, anchor.nextSibling);

    var btn = $('.pw-add', wrap), msg = $('.pw-msg', wrap);
    function showHintIfCustom() {
      if (document.querySelector('[name^="properties["], input[type="file"], [class*="uploadly" i], [id*="uploadly" i], [class*="textify" i], [id*="textify" i]')) {
        $('.pw-hint', wrap).hidden = false;
      }
    }
    showHintIfCustom(); setTimeout(showHintIfCustom, 2500);

    btn.addEventListener('click', function () {
      var state = load();
      if (state.finished) {
        msg.innerHTML = 'Your wishlist is finished. To add this, <a href="' + esc(wishlistUrl('edit=1')) + '">edit your wishlist →</a>';
        return;
      }
      var sel = captureSelection();
      if (!sel.v) { msg.textContent = 'Please choose your options first.'; return; }
      var p = CFG.product;
      var variant = (p.variants || []).filter(function (x) { return String(x.id) === String(sel.v); })[0] || {};
      var item = {
        h: p.handle, v: Number(sel.v), p: sel.p,
        t: p.title, vt: variant.title && variant.title !== 'Default Title' ? variant.title : '',
        img: variant.image || p.image || ''
      };
      if (state.items.some(function (x) { return sameItem(x, item); })) {
        msg.innerHTML = 'Already on your wishlist. <a href="' + esc(wishlistUrl()) + '">View wishlist →</a>';
        return;
      }
      if (state.items.length >= MAX_ITEMS) { msg.textContent = 'Your wishlist is full (' + MAX_ITEMS + ' items).'; return; }
      state.items.push(item); save(state);
      btn.classList.add('is-added');
      $('.pw-heart', btn).innerHTML = '&#9829;';
      $('.pw-add-label', btn).textContent = 'Added to Wishlist';
      msg.innerHTML = '<a href="' + esc(wishlistUrl()) + '">View my wishlist (' + state.items.length + ') →</a>';
      if (new URLSearchParams(location.search).get('wl_debug')) {
        msg.innerHTML += '<pre class="pw-debug">' + esc(JSON.stringify(item, null, 2)) + '</pre>';
      }
      updatePill();
    });
  }

  /* ---------- floating pill ---------- */
  var pill;
  function updatePill() {
    if (!pill) return;
    var s = load();
    if (!s.items.length) { pill.hidden = true; return; }
    pill.hidden = false;
    pill.innerHTML = '<span aria-hidden="true">&#9829;</span> ' + (s.finished ? 'My wishlist' : 'Wishlist · ' + s.items.length);
  }
  function initPill() {
    if (CFG.isWishlistPage || CFG.product) return;
    pill = document.createElement('a');
    pill.className = 'pw-pill'; pill.href = wishlistUrl(); pill.hidden = true;
    document.body.appendChild(pill);
    updatePill();
  }

  /* ---------- Instagram images (image only + light branding) ---------- */
  function loadImg(src) {
    return new Promise(function (res) {
      var img = new Image(); img.crossOrigin = 'anonymous';
      img.onload = function () { res(img); }; img.onerror = function () { res(null); };
      img.src = src;
    });
  }
  function roundRect(ctx, x, y, w, h, r) {
    ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath();
  }
  function drawCover(ctx, img, x, y, w, h) {
    var ir = img.width / img.height, r = w / h, sw, sh, sx, sy;
    if (ir > r) { sh = img.height; sw = sh * r; sx = (img.width - sw) / 2; sy = 0; }
    else { sw = img.width; sh = sw / r; sx = 0; sy = (img.height - sh) / 2; }
    ctx.drawImage(img, sx, sy, sw, sh, x, y, w, h);
  }
  function possessive(name) { name = (name || '').trim(); if (!name) return 'My'; return /s$/i.test(name) ? name + '’' : name + '’s'; }

  function wrapLines(ctx, text, maxW, maxLines) {
    var words = String(text).split(/\s+/), lines = [], line = '';
    for (var i = 0; i < words.length; i++) {
      var test = line ? line + ' ' + words[i] : words[i];
      if (ctx.measureText(test).width <= maxW || !line) { line = test; }
      else { lines.push(line); line = words[i]; if (lines.length === maxLines) break; }
    }
    if (lines.length < maxLines && line) lines.push(line);
    if (lines.length === maxLines && words.join(' ') !== lines.join(' ')) {
      var last = lines[maxLines - 1];
      while (ctx.measureText(last + '…').width > maxW && last.length > 1) last = last.slice(0, -1);
      lines[maxLines - 1] = last.replace(/[\s\-–]+$/, '') + '…';
    }
    return lines;
  }

  function makeImage(format, name, items) {
    // items: [{ url, title }]
    var W = 1080, H = format === 'story' ? 1920 : 1350, story = format === 'story';
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var ctx = c.getContext('2d');
    var fontsReady = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
    var shown = items.slice(0, 9);
    return fontsReady.then(function () {
      var logoSrc = CFG.imageLogoUrl || CFG.logoUrl;
      return Promise.all([logoSrc ? loadImg(abs(logoSrc)) : Promise.resolve(null)].concat(
        shown.map(function (it) { return loadImg(abs(it.url, 900)); })));
    }).then(function (loaded) {
      var logo = loaded[0], imgs = loaded.slice(1);
      ctx.fillStyle = BRAND.bg; ctx.fillRect(0, 0, W, H);
      var heading = (CFG.headingFont || 'Montserrat') + ', Georgia, serif';
      ctx.textAlign = 'center'; ctx.textBaseline = 'alphabetic';

      // logo
      var y = story ? 150 : 60;
      if (logo) {
        var ratio = logo.width / logo.height;
        var lh = ratio < 1.6 ? (story ? 230 : 170) : (story ? 150 : 110), lw = lh * ratio;
        if (lw > 560) { lw = 560; lh = lw * (logo.height / logo.width); }
        ctx.drawImage(logo, (W - lw) / 2, y, lw, lh); y += lh + (story ? 140 : 110);
      } else {
        ctx.fillStyle = BRAND.ink; ctx.font = '600 40px ' + heading; ctx.fillText('Potato & Co.', W / 2, y + 40); y += 100;
      }
      // title
      ctx.fillStyle = BRAND.ink;
      var size = 60; ctx.font = '600 ' + size + 'px ' + heading;
      var title = possessive(name) + ' Wishlist';
      while (ctx.measureText(title).width > W - 140 && size > 34) { size -= 4; ctx.font = '600 ' + size + 'px ' + heading; }
      ctx.fillText(title, W / 2, y); y += 40;

      // footer area
      var footH = story ? 260 : 130;
      var gx = 70, gy = y + 10, gw = W - 140, gh = H - gy - footH, g = 26;

      // grid
      var n = shown.length, extra = items.length - n;
      var cols = n <= 1 ? 1 : (n <= 4 ? 2 : 3);
      if (story && n === 2) cols = 1;
      var rows = Math.ceil(n / cols);
      var nameFont = cols === 1 ? 30 : (cols === 2 ? 26 : 22);
      var nameH = Math.round(nameFont * 2.6) + 12;
      var s = Math.min((gw - (cols - 1) * g) / cols, (gh - (rows - 1) * g - rows * nameH) / rows);
      var cellH = s + nameH;
      var totalW = cols * s + (cols - 1) * g, totalH = rows * cellH + (rows - 1) * g;
      var ox = gx + (gw - totalW) / 2, oy = gy + (gh - totalH) / 2;
      for (var i = 0; i < n; i++) {
        var rIdx = Math.floor(i / cols), cIdx = i % cols;
        var inRow = Math.min(cols, n - rIdx * cols);
        var rowOffset = (cols - inRow) * (s + g) / 2;
        var x = ox + rowOffset + cIdx * (s + g), ty = oy + rIdx * (cellH + g);
        ctx.save(); roundRect(ctx, x, ty, s, s, 24); ctx.fillStyle = BRAND.tile; ctx.fill(); ctx.clip();
        if (imgs[i]) drawCover(ctx, imgs[i], x, ty, s, s);
        if (i === n - 1 && extra > 0) {
          ctx.fillStyle = 'rgba(54,38,36,.55)'; ctx.fillRect(x, ty, s, s);
          ctx.fillStyle = '#fff'; ctx.font = '600 ' + Math.round(s / 4) + 'px ' + heading;
          ctx.fillText('+' + extra, x + s / 2, ty + s / 2 + s / 12);
        }
        ctx.restore();
        // product name under the photo
        ctx.fillStyle = BRAND.ink; ctx.font = '500 ' + nameFont + 'px ' + heading;
        var lines = wrapLines(ctx, shown[i].title || '', s - 8, 2);
        lines.forEach(function (ln, k) { ctx.fillText(ln, x + s / 2, ty + s + nameFont + 10 + k * Math.round(nameFont * 1.25)); });
      }

      // footer
      var fy = H - (story ? 190 : 72);
      ctx.fillStyle = BRAND.ink; ctx.font = '600 34px ' + heading;
      ctx.fillText('Make your wishlist at potatoandco.com', W / 2, fy);
      ctx.fillStyle = BRAND.soft; ctx.font = '500 26px ' + heading;
      ctx.fillText('@potatoand.co', W / 2, fy + 42);
      return new Promise(function (res, rej) {
        try { c.toBlob(function (b) { b ? res(b) : rej(new Error('blob')); }, 'image/png'); } catch (e) { rej(e); }
      });
    });
  }
  function deliverImage(blob, filename) {
    var file;
    try { file = new File([blob], filename, { type: 'image/png' }); } catch (e) { file = null; }
    if (file && navigator.canShare && navigator.canShare({ files: [file] }) && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) {
      return navigator.share({ files: [file] }).catch(function () {});
    }
    var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = filename;
    document.body.appendChild(a); a.click();
    setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 4000);
    return Promise.resolve();
  }

  /* ---------- editing a finished list ---------- */
  function startEdit(root) {
    var st = load();
    if (!st.finished) return renderBuilder(root);
    // Give every item a stable number the first time a list is edited.
    // Lists made before editing existed used the item's position as its number.
    if (!st.numbered) {
      st.items.forEach(function (it, i) { if (it.n == null) it.n = i; });
      st.numbered = true;
    }
    var maxN = -1;
    st.items.forEach(function (it) { if (it.n != null && it.n > maxN) maxN = it.n; });
    st.nextN = Math.max(st.nextN || 0, maxN + 1);
    st.prevItems = JSON.parse(JSON.stringify(st.items));
    st.prevLink = st.link;
    st.finished = false;
    st.editing = true;
    save(st);
    renderBuilder(root);
    window.scrollTo(0, 0);
  }
  function cancelEdit(root) {
    var st = load();
    if (!st.editing || !st.prevLink) return renderBuilder(root);
    st.items = st.prevItems || st.items;
    st.link = st.prevLink;
    st.finished = true;
    st.editing = false;
    delete st.prevItems; delete st.prevLink;
    save(st);
    renderFinished(root, st);
    window.scrollTo(0, 0);
  }

  /* ---------- wishlist page ---------- */
  function renderBuilder(root) {
    var s = load();
    if (s.finished) return renderFinished(root, s);
    var editing = !!s.editing;
    var cancelHtml = editing ? '<p class="pw-small"><button type="button" class="pw-cancel-edit">Cancel and keep my current link</button></p>' : '';
    root.onclick = function (e) {
      if (e.target.closest('.pw-cancel-edit')) { cancelEdit(root); return; }
      var b = e.target.closest('.pw-remove'); if (!b) return;
      var st = load(); st.items.splice(Number(b.getAttribute('data-i')), 1); save(st); renderBuilder(root);
    };
    if (!s.items.length) {
      root.innerHTML = '<div class="pw-empty"><h1 class="pw-title">' + (editing ? 'Edit your wishlist' : 'Your Wishlist') + '</h1>' +
        '<p>Tap <strong>&#9825; Add to Wishlist</strong> on any product to ' + (editing ? 'add it to your list' : 'start your list') + '. Pick your size, colour and any custom details first, and we’ll save exactly that.</p>' +
        '<a class="pw-btn" href="/collections/all">Start browsing</a>' + cancelHtml + '</div>';
      return;
    }
    root.innerHTML =
      '<h1 class="pw-title">' + (editing ? 'Edit your wishlist' : 'Your Wishlist') + '</h1>' +
      (editing
        ? '<p class="pw-sub">Remove anything you’ve changed your mind about, or keep shopping and tap Add to Wishlist to add more. When you’re done, save your changes to get your new link.</p>' +
          '<div class="pw-edit-more"><a class="pw-btn pw-btn--outline" href="/collections/all">Add more items</a></div>'
        : '<p class="pw-sub">Review your picks. When you’re happy, finish your list to get your share link and Instagram images.</p>') +
      '<p class="pw-count">' + s.items.length + ' of ' + MAX_ITEMS + ' items</p>' +
      '<ul class="pw-items">' + s.items.map(function (it, i) {
        return '<li class="pw-item"><img src="' + esc(abs(it.img, 300)) + '" alt="" loading="lazy">' +
          '<div class="pw-item__info"><a class="pw-item__title" href="/products/' + esc(it.h) + '?variant=' + esc(it.v) + '">' + esc(it.t) + '</a>' +
          (it.vt ? '<div class="pw-item__variant">' + esc(it.vt) + '</div>' : '') + propsHtml(it.p) + '</div>' +
          '<button type="button" class="pw-remove" data-i="' + i + '" aria-label="Remove ' + esc(it.t) + '">Remove</button></li>';
      }).join('') + '</ul>' +
      '<form class="pw-finish" novalidate>' +
      '<label class="pw-label" for="pwName">Whose wishlist is this?</label>' +
      '<input class="pw-input" id="pwName" maxlength="40" placeholder="e.g. Leja & Potato" required value="' + esc(s.name || '') + '">' +
      '<label class="pw-label" for="pwNote">Note for gift-givers <span>(optional)</span></label>' +
      '<textarea class="pw-input" id="pwNote" maxlength="160" rows="2" placeholder="e.g. Potato is 22 lb with an 18 in chest">' + esc(s.note || '') + '</textarea>' +
      '<p class="pw-warn">' + (editing
        ? 'Saving gives you a <strong>new link</strong>. Your old link won’t show these changes, so you’ll need to share the new one.'
        : 'You can edit your list later, but editing gives you a new link to share.') + '</p>' +
      '<button class="pw-btn" type="submit">' + (editing ? 'Save changes &amp; get my new link' : 'Finish my wishlist') + '</button><p class="pw-msg" role="status"></p></form>' +
      cancelHtml;

    $('.pw-finish', root).addEventListener('submit', function (e) {
      e.preventDefault();
      var name = $('#pwName', root).value.trim(), note = $('#pwNote', root).value.trim();
      var m = $('.pw-finish .pw-msg', root);
      if (!name) { m.textContent = 'Please add a name for your wishlist.'; $('#pwName', root).focus(); return; }
      var st = load();
      var wasEditing = !!st.editing;
      if (!confirm(wasEditing
        ? 'Save your changes? You’ll get a NEW link. Your old link won’t show these changes.'
        : 'Finish your wishlist? You can still edit it later, but editing gives you a new link.')) return;
      var listId = (wasEditing && st.listId) ? st.listId : newListId();
      var rows;
      if (st.numbered) {
        if (st.nextN == null) st.nextN = 0;
        st.items.forEach(function (it) { if (it.n == null) it.n = st.nextN++; });
        rows = st.items.map(function (it) { return [it.h, it.v, it.p || {}, it.n]; });
      } else {
        rows = st.items.map(function (it) { return [it.h, it.v, it.p || {}]; });
      }
      var payload = { v: 1, k: listId, n: name, o: note, i: rows };
      encodeList(payload).then(function (code) {
        var link = location.origin + wishlistUrl('l=' + code);
        if (CFG.previewThemeId) link += '&preview_theme_id=' + CFG.previewThemeId;
        st.finished = true; st.link = link; st.name = name; st.note = note; st.listId = listId;
        if (wasEditing) {
          st.updated = true;
          st.editCount = (st.editCount || 0) + 1;
          delete st.shortLink;
        }
        st.editing = false;
        delete st.prevItems; delete st.prevLink;
        save(st);
        renderFinished(root, st);
        window.scrollTo(0, 0);
      });
    });
  }

  function renderFinished(root, s) {
    root.onclick = null;
    root.innerHTML =
      '<div class="pw-done">' + logoHtml() + '<p class="pw-eyebrow">' + (s.updated ? 'Your wishlist is updated' : 'Your wishlist is ready') + '</p>' +
      '<h1 class="pw-title">' + esc(possessive(s.name)) + ' Wishlist</h1>' +
      (s.updated
        ? '<div class="pw-newlink" role="alert"><p><strong>This is your NEW wishlist link. Your previous link is no longer up to date and won’t show your changes.</strong></p>' +
          '<p>Please replace your old link everywhere you shared it: your link in bio, Instagram stories, and any texts or emails.</p></div>'
        : '') +
      '<p class="pw-sub">Share this link with family and friends, or add it to your link in bio. It shows your exact sizes, colours and custom details so anyone can buy exactly what you want.</p>' +
      (s.updated ? '<p class="pw-label pw-newlink__label">Your NEW link</p>' : '') +
      '<div class="pw-link"><input class="pw-input" readonly value="' + esc(s.link) + '" aria-label="' + (s.updated ? 'Your new wishlist link' : 'Your wishlist link') + '">' +
      '<button type="button" class="pw-btn pw-copy">' + (s.updated ? 'Copy new link' : 'Copy link') + '</button></div>' +
      (navigator.share ? '<button type="button" class="pw-btn pw-btn--outline pw-share">Share link</button>' : '') +
      '<h2 class="pw-h2">Show it off on Instagram</h2>' +
      '<p class="pw-sub">Download a picture of your favourites. Add your link with a link sticker in Stories.</p>' +
      '<div class="pw-dl"><button type="button" class="pw-btn pw-btn--outline" data-fmt="post">Instagram post (4:5)</button>' +
      '<button type="button" class="pw-btn pw-btn--outline" data-fmt="story">Instagram story (9:16)</button></div>' +
      '<p class="pw-msg" role="status"></p>' +
      '<p class="pw-small"><a href="' + esc(s.link) + '">Preview what your family will see →</a></p>' +
      '<div class="pw-edit-box"><h2 class="pw-h2">Need to make changes?</h2>' +
      '<p class="pw-sub">Add or remove items any time. Saving your changes gives you a new link to share.</p>' +
      '<button type="button" class="pw-btn pw-btn--outline pw-edit">Edit my wishlist</button></div></div>';

    $('.pw-edit', root).addEventListener('click', function () { startEdit(root); });

    var msg = $('.pw-done > .pw-msg', root);
    $('.pw-copy', root).addEventListener('click', function () {
      var inp = $('.pw-link input', root);
      (navigator.clipboard ? navigator.clipboard.writeText(s.link) : Promise.reject()).then(function () {
        msg.textContent = 'Link copied!';
      }).catch(function () { inp.select(); document.execCommand('copy'); msg.textContent = 'Link copied!'; });
    });
    var sh = $('.pw-share', root);
    if (sh) sh.addEventListener('click', function () {
      navigator.share({ title: possessive(s.name) + ' Wishlist · Potato & Co.', url: s.link }).catch(function () {});
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-fmt]'), function (b) {
      b.addEventListener('click', function () {
        var fmt = b.getAttribute('data-fmt');
        msg.textContent = 'Creating your image…';
        Promise.all(s.items.map(function (it) {
          return fetchProduct(it.h).then(function (p) {
            var v = (p.variants || []).filter(function (x) { return String(x.id) === String(it.v); })[0];
            return { url: (v && v.featured_image && v.featured_image.src) || p.featured_image || it.img, title: p.title };
          }).catch(function () { return { url: it.img, title: it.t }; });
        })).then(function (list) {
          return makeImage(fmt, s.name, list.filter(function (x) { return x.url; }));
        }).then(function (blob) {
          msg.textContent = '';
          return deliverImage(blob, 'potato-wishlist-' + fmt + '.png');
        }).catch(function () {
          msg.textContent = 'Sorry, the image couldn’t be created on this browser. Please try again in Safari or Chrome.';
        });
      });
    });
  }

  function logoHtml() {
    return CFG.logoUrl
      ? '<a class="pw-logo" href="/"><img src="' + esc(abs(CFG.logoUrl)) + '" alt="Potato &amp; Co."></a>'
      : '<p class="pw-eyebrow">Potato &amp; Co.</p>';
  }

  function renderShared(root, code) {
    root.innerHTML = '<p class="pw-sub">Loading wishlist…</p>';
    decodeList(code).then(function (data) {
      if (!data || !Array.isArray(data.i)) throw new Error('bad');
      var owner = !!data.k && load().listId === data.k;
      return Promise.all([owner ? Promise.resolve([]) : fetchGifted(data.k)].concat(data.i.slice(0, MAX_ITEMS).map(function (row, idx) {
        var handle = row[0], vid = row[1], props = row[2] || {};
        if (row[3] != null && !isNaN(Number(row[3]))) idx = Number(row[3]);
        return fetchProduct(handle).then(function (p) {
          var v = (p.variants || []).filter(function (x) { return String(x.id) === String(vid); })[0];
          return { ok: !!v, p: p, v: v, props: props, handle: handle, idx: idx };
        }).catch(function () { return { ok: false, handle: handle, props: props, idx: idx }; });
      }))).then(function (all) {
        var gifted = all[0];
        var rows = all.slice(1);
        rows.forEach(function (r) { r.gifted = gifted.indexOf(String(r.idx)) > -1; });
        return { data: data, rows: rows };
      });
    }).then(function (res) {
      var data = res.data, rows = res.rows.filter(function (r) { return r.ok; });
      root.innerHTML =
        logoHtml() +
        '<h1 class="pw-title">' + esc(possessive(data.n)) + ' Wishlist</h1>' +
        (data.o ? '<p class="pw-note">“' + esc(data.o) + '”</p>' : '') +
        '<p class="pw-sub">Everything here is saved with the exact size, colour and custom details they chose. Just add to cart.</p>' +
        '<ul class="pw-items pw-items--shared">' + rows.map(function (r, i) {
          var v = r.v, img = (v.featured_image && v.featured_image.src) || r.p.featured_image;
          var vt = v.title && v.title !== 'Default Title' ? v.title : '';
          var action = r.gifted
            ? '<button type="button" class="pw-btn pw-btn--outline" disabled>Already gifted</button>'
            : (v.available
              ? '<button type="button" class="pw-btn pw-add-cart" data-i="' + i + '">Add to cart</button>'
              : '<button type="button" class="pw-btn" disabled>Sold out</button>');
          return '<li class="pw-item' + (r.gifted ? ' pw-item--gifted' : '') + '"><a href="/products/' + esc(r.handle) + '?variant=' + esc(v.id) + '"><img src="' + esc(abs(img, 400)) + '" alt="' + esc(r.p.title) + '" loading="lazy"></a>' +
            '<div class="pw-item__info"><a class="pw-item__title" href="/products/' + esc(r.handle) + '?variant=' + esc(v.id) + '">' + esc(r.p.title) + '</a>' +
            (r.gifted ? '<div class="pw-gifted">&#127873; Gifted</div>' : '') +
            (vt ? '<div class="pw-item__variant">' + esc(vt) + '</div>' : '') + propsHtml(r.props) +
            '<div class="pw-item__price">' + money(v.price) + '</div></div>' + action + '</li>';
        }).join('') + '</ul>' +
        (rows.filter(function (r) { return r.v.available && !r.gifted; }).length > 1 ? '<button type="button" class="pw-btn pw-add-all">Add all to cart</button>' : '') +
        '<p class="pw-msg" role="status"></p>' +
        (res.rows.length > rows.length ? '<p class="pw-small">Some items on this list are no longer available.</p>' : '') +
        '<div class="pw-cta"><p class="pw-cta__title">Make your wishlist on potatoandco.com</p>' +
        '<p class="pw-sub">Save your favourites with your sizes, colours and custom details, then share one link.</p>' +
        '<div class="pw-more"><a class="pw-btn" href="' + esc(wishlistUrl()) + '">Make my wishlist</a> ' +
        '<a class="pw-btn pw-btn--outline" href="/collections/all">Shop more favourites</a></div></div>';

      var msg = $('.pw-msg', root);
      function lineProps(r) {
        var out = {};
        Object.keys(r.props || {}).forEach(function (k) { out[k] = r.props[k]; });
        if (data.k) { out._wishlist = data.k; out._wishlist_item = String(r.idx); }
        return out;
      }
      function refreshCartCount() {
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
          Array.prototype.forEach.call(document.querySelectorAll('.cart-count-number'), function (el) { el.textContent = cart.item_count; });
          Array.prototype.forEach.call(document.querySelectorAll('.header__cart-count'), function (el) {
            el.classList.remove('opacity-0', 'hidden-xs');
          });
          return cart;
        }).catch(function () {});
      }
      // Fallback: the classic cart form post always works and lands on the cart page.
      function addWithForm(list) {
        var f = document.createElement('form');
        f.method = 'post'; f.action = '/cart/add'; f.style.display = 'none';
        function field(n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; f.appendChild(i); }
        list.forEach(function (r, i) {
          field('items[' + i + '][id]', r.v.id); field('items[' + i + '][quantity]', 1);
          var lp = lineProps(r);
          Object.keys(lp).forEach(function (k) { field('items[' + i + '][properties][' + k + ']', lp[k]); });
        });
        field('return_to', '/cart');
        document.body.appendChild(f); f.submit();
      }
      function add(list, btn) {
        if (btn) btn.disabled = true;
        msg.textContent = 'Adding…';
        return fetch('/cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: list.map(function (r) { return { id: Number(r.v.id), quantity: 1, properties: lineProps(r) }; }) })
        }).then(function (resp) {
          return resp.json().then(function (j) { if (!resp.ok) { var e = new Error(j.description || j.message || 'add'); e.status = resp.status; throw e; } return j; });
        }).then(function () {
          return refreshCartCount().then(function () {
            msg.innerHTML = 'Added to your cart. <a href="/cart">View cart &amp; check out →</a>';
            if (btn) btn.textContent = 'Added ✓';
          });
        }).catch(function (err) {
          if (err && err.status === 422) {
            msg.textContent = 'Sorry, that couldn’t be added: ' + err.message;
            if (btn) btn.disabled = false;
            return;
          }
          addWithForm(list);
        });
      }
      Array.prototype.forEach.call(root.querySelectorAll('.pw-add-cart'), function (b) {
        b.addEventListener('click', function () { add([rows[Number(b.getAttribute('data-i'))]], b); });
      });
      var all = $('.pw-add-all', root);
      if (all) all.addEventListener('click', function () { add(rows.filter(function (r) { return r.v.available && !r.gifted; }), all); });
    }).catch(function () {
      root.innerHTML = '<h1 class="pw-title">Wishlist not found</h1><p class="pw-sub">This link looks incomplete. Ask the person who shared it to send it again.</p>' +
        '<a class="pw-btn" href="/collections/all">Shop Potato &amp; Co.</a>';
    });
  }

  function initPage() {
    var root = document.getElementById('PotatoWishlistRoot');
    if (!root) return;
    var params = new URLSearchParams(location.search);
    var code = params.get('l');
    if (code) renderShared(root, code);
    else if (params.get('edit') === '1' && load().finished) startEdit(root);
    else renderBuilder(root);
  }

  function boot() { initProductButton(); initPill(); initPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
